/**
 * WhiskyType
 */
export type WhiskyType =
  | 'BLENDED'
  | 'BLENDED_MALT'
  | 'BOURBON'
  | 'CORN'
  | 'OTHER_WHISKYS'
  | 'SINGLE_MALT'
  | 'SINGLE_GRAIN'
  | 'STRAIGHT_RYE'
  | 'TENNESSEE'
  | 'OTHER';

export const WhiskyType = {
  Blended: 'BLENDED' as WhiskyType,
  BlendedMalt: 'BLENDED_MALT' as WhiskyType,
  Bourbon: 'BOURBON' as WhiskyType,
  Corn: 'CORN' as WhiskyType,
  OtherWhiskys: 'OTHER_WHISKYS' as WhiskyType,
  SingleMalt: 'SINGLE_MALT' as WhiskyType,
  SingleGrain: 'SINGLE_GRAIN' as WhiskyType,
  StraightRye: 'STRAIGHT_RYE' as WhiskyType,
  Tennessee: 'TENNESSEE' as WhiskyType,
  Other: 'OTHER' as WhiskyType,
};
